import React from 'react';

function SelectCard({ selected = false, className = '', children, ...props }) {
  return (
    <button
      className={`ui-select-card ${selected ? 'is-selected' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export default SelectCard;
